import React, {useEffect} from 'react'
import {Box, Grid, Typography} from "@mui/material";
import Subtitle from "../../components/Subtitle";
import TreeTypeTable from "../../components/TreeTypeTable";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {useTranslation} from "react-i18next";
import {getCurrentLanguage} from "../../utils/Helpers";

const EuropeanCitiesTreeSpeciesLayout =()=>{
    const dispatch = useAppDispatch();
    const {t, i18n}= useTranslation();
    let key = getCurrentLanguage(i18n);
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/european-cities",
            type:"pageView"
        }))
    }, []);
    return(
        <React.Fragment>
            <Box component="main">
                <Subtitle/>
                <br/>
                <br/>
                <Typography variant="h4" style={{fontWeight: "bold"}}>
                    {t('european_tree_species.title' as any)}
                </Typography>
                <br/>
                <Typography paragraph>
                    {t('european_tree_species.paragraph_1' as any)}
                </Typography>
                <Typography paragraph>
                    {t('european_tree_species.paragraph_2' as any)}
                </Typography>
                <Grid container alignItems='center' justifyContent='center'>
                    <Grid item xs='auto'>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                maxWidth: "95%"
                            }}
                            component="img"
                            alt="Table Sealing 1"
                            src={require("../../assets/pages/detail/european_cities/"+key+"/diagramm-baumarten.png")}
                        />
                    </Grid>
                </Grid>
                <Typography style={{alignItems: "center", marginTop: 16, textAlign: "center", justifyContent: "center"}}
                            paragraph>
                    {t('european_tree_species.diagram_1' as any)}
                </Typography>
                <br/>
                <Typography paragraph>
                    {t('european_tree_species.paragraph_3' as any)}
                </Typography>
                <Typography paragraph>
                    {t('european_tree_species.paragraph_4' as any)}
                </Typography>
                <TreeTypeTable />
            </Box>
        </React.Fragment>
    )
}
export default EuropeanCitiesTreeSpeciesLayout
